import { AdapterBase, RunResponseType } from "../../storyV2/adapter/AdapterBase";
export class VietnameseStoryboardAdapter extends AdapterBase {
    runResponseType() {
        return RunResponseType.STREAM;
    }
}
